import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initPosthog } from './posthog';
import './index.css';

initPosthog();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
